<template>
  <div>
    <div class="app-content--inner p-0 d-flex flex-column">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <h3 class="text-uppercase" style="color:#6190bf">
              tambah data dokter
            </h3>
            <br />

            <b-form @submit.prevent="submitInputDokter">
              <b-row class="d-flex align-items-center">
                <b-col
                  sm="12"
                  v-for="(inputDokter, index) in tmpInputDokterData"
                  :key="inputDokter.id"
                >
                  <div class="card card-box mb-3">
                    <div class="card-body">
                      <b-row class="d-flex align-items-center mb-2">
                        <b-col lg="3" sm="3" v-show="bpjsAuthValid">
                          <label class="font-weight-bold">Kode Dokter BPJS</label>
                          <p class="font-weight-bold m-0 text-primary" style="font-size:10px;">Pilih kode dokter jika dokter terdaftar di Pcare</p>
                          <p class="font-weight-bold m-0 text-white" style="font-size:10px;">space</p>
                        </b-col>
                        <b-col lg="3" sm="3">
                          <label class="font-weight-bold">Nama Dokter</label>
                          <label style="color:red"> *</label>
                          <p class="font-weight-bold m-0 text-primary" style="font-size:10px;">Lengkap dengan gelar depan & belakang jika ada</p>
                          <p class="font-weight-bold m-0 text-danger" style="font-size:10px;">Cth:Prof.dr.John Wick, Sp.PD</p>
                        </b-col>
                        <b-col sm="3">
                          <label class="font-weight-bold">Alamat Email</label>
                          <label style="color:red"> *</label>
                        </b-col>
                        <b-col lg="3" sm="3">                          
                          <label class="font-weight-bold">No. Handphone</label>
                          <label style="color:red"> *</label>
                        </b-col>
                        <b-col lg="3" sm="3" v-show="!bpjsAuthValid">
                          <label class="font-weight-bold">Spesialisasi</label>
                          <label style="color:red"> *</label>
                        </b-col>
                      </b-row>
                      <b-row class="d-flex align-items-center mb-3">
                        <b-col lg="3" sm="3" v-show="bpjsAuthValid">
                            <vue-select
                              style="font-size:13px"
                              :options="dokterBpjsList"
                              v-model="tmpInputDokterData[index].kode_dokter_bpjs"
                              :ref="'kode_dokter_bpjs' + index"
                              placeholder="Pilih Kode Dokter BPJS"
                              :keyOpt="'kode_dokter_bpjs'"
                              :isClearable="true"
                              @change="
                                onChangeValue({
                                  label: 'kode_dokter_bpjs',
                                  index,
                                  $event
                                })
                              "
                              @input="
                                onInputKodeBpjs(
                                  $event,
                                  index,
                                  inputDokter,
                                  'kode_dokter_bpjs'
                                )
                              "
                            >
                            </vue-select>

                            <b-form-invalid-feedback>
                              {{
                                inputDokter.error &&
                                inputDokter.error.kode_dokter_bpjs.desc
                              }}
                            </b-form-invalid-feedback>
                        </b-col>
                        <b-col lg="3" sm="3">
                          <div role="group">
                            <b-form-input
                              v-model="tmpInputDokterData[index].nama"
                              :ref="'nama' + index"
                              @change="
                                onChangeValue({
                                  label: 'nama',
                                  index,
                                  $event
                                })
                              "
                              @input="
                                onInputData(
                                  $event,
                                  index,
                                  inputDokter,
                                  'nama'
                                )
                              "
                              :state="
                                errorState({ label: 'nama', index })
                              "
                              maxlength="50"
                            >
                            </b-form-input>
                            <b-form-invalid-feedback>
                              {{
                                inputDokter.error &&
                                  inputDokter.error.nama.desc
                              }}
                            </b-form-invalid-feedback>
                          </div>
                        </b-col>
                        <b-col sm="3">
                          <div role="group">
                            <b-form-input
                              type="email"
                              v-model="tmpInputDokterData[index].email"
                              :ref="'email' + index"
                              @change="
                                onChangeValue({
                                  label: 'email',
                                  index,
                                  $event
                                })
                              "
                              @input="
                                onInputEmail(
                                  $event,
                                  index,
                                  inputDokter,
                                  'email'
                                )
                              "
                              :state="
                                errorState({ label: 'email', index })
                              "
                              maxlength="50"
                            ></b-form-input>
                            <b-form-invalid-feedback>
                              {{
                                inputDokter.error &&
                                  inputDokter.error.email.desc
                              }}
                            </b-form-invalid-feedback>
                          </div>
                        </b-col>
                        <b-col sm="3">
                          <div role="group">
                            <b-form-input
                              v-model="tmpInputDokterData[index].nomor_telp"
                              :ref="'nomor_telp' + index"
                              @change="
                                onChangeValue({
                                  label: 'nomor_telp',
                                  index,
                                  $event
                                })
                              "
                              @input="
                                onInputNomorTelp(
                                  $event,
                                  index,
                                  inputDokter,
                                  'nomor_telp'
                                )
                              "
                              :state="
                                errorState({ label: 'nomor_telp', index })
                              "
                              maxlength="15"
                            ></b-form-input>
                            <b-form-invalid-feedback>
                              {{
                                inputDokter.error &&
                                inputDokter.error.nomor_telp.desc
                              }}
                            </b-form-invalid-feedback>
                          </div>
                        </b-col>
                        <b-col lg="3" sm="3" v-show="!bpjsAuthValid">
                          <div role="group">
                            <vue-select
                              style="font-size:13px"
                              :options="spesialisasiList"
                              v-model="tmpInputDokterData[index].spesialisasi"
                              :ref="'spesialisasi' + index"
                              placeholder="Pilih Spesialisasi"
                              @change="
                                onChangeValue({
                                  label: 'spesialisasi',
                                  index,
                                  $event
                                })
                              "
                              @input="
                                onInputData(
                                  $event,
                                  index,
                                  inputDokter,
                                  'spesialisasi'
                                )
                              "
                            />

                            <b-form-invalid-feedback>
                              {{
                                inputDokter.error &&
                                inputDokter.error.spesialisasi.desc
                              }}
                            </b-form-invalid-feedback>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row class="d-flex align-items-center mb-2">
                        <b-col sm="3" v-show="bpjsAuthValid">
                          <label class="font-weight-bold">Spesialisasi</label>
                          <label style="color:red"> *</label>
                        </b-col>
                        <b-col lg="3" sm="3">
                          <label class="font-weight-bold">SIP Dokter</label>
                          <label style="color:red"> *</label>
                          <p class="font-weight-bold m-0 text-primary" style="font-size:10px;">Lengkap dengan simbol/tanda baca</p>
                          <p class="font-weight-bold m-0 text-danger" style="font-size:10px;">Cth:446/015/SIP-DS/III.00-WW/IV/2019</p>
                        </b-col>
                        <b-col lg="3" sm="3">
                          <label class="font-weight-bold">Masa Berlaku SIP</label>
                          <label style="color:red"> *</label>
                        </b-col>
                        <b-col lg="3" sm="3">
                            <label class="font-weight-bold">NIK</label>
                            <label style="color:red"> *</label>
                        </b-col>
                      </b-row>
                      <b-row class="d-flex align-items-center mb-3">
                        <b-col lg="3" sm="3" v-show="bpjsAuthValid">
                          <div role="group">
                            <vue-select
                              style="font-size:13px"
                              :options="spesialisasiList"
                              v-model="tmpInputDokterData[index].spesialisasi"
                              :ref="'spesialisasi' + index"
                              placeholder="Pilih Spesialisasi"
                              @change="
                                onChangeValue({
                                  label: 'spesialisasi',
                                  index,
                                  $event
                                })
                              "
                              @input="
                                onInputData(
                                  $event,
                                  index,
                                  inputDokter,
                                  'spesialisasi'
                                )
                              "
                            />

                            <b-form-invalid-feedback>
                              {{
                                inputDokter.error &&
                                inputDokter.error.spesialisasi.desc
                              }}
                            </b-form-invalid-feedback>
                          </div>
                        </b-col>
                        <b-col sm="3">
                          <div role="group">
                            <b-form-input
                              :value="tmpInputDokterData[index].nomor_sip"
                              v-model="tmpInputDokterData[index].nomor_sip"
                              :ref="'nomor_sip' + index"
                              @change="
                                onChangeValue({
                                  label: 'nomor_sip',
                                  index,
                                  $event
                                })
                              "
                              @input="
                                onInputSIP(
                                  $event,
                                  index,
                                  inputDokter,
                                  'nomor_sip'
                                )
                              "
                              :state="
                                errorState({ label: 'nomor_sip', index })
                              "
                            ></b-form-input>
                            <b-form-invalid-feedback>
                              {{
                                inputDokter.error &&
                                inputDokter.error.nomor_sip.desc
                              }}
                            </b-form-invalid-feedback>
                          </div>
                        </b-col>
                        <b-col sm="3">
                          <b-form-group class="mt-3">
                            <DatePickerX
                              v-model="tmpInputDokterData[index].masa_berlaku"
                              :ref="'masa_berlaku' + index"
                              @input="
                                onInputData(
                                  $event,
                                  index,
                                  inputDokter,
                                  'masa_berlaku'
                                )
                              "
                            >
                              <template v-slot="{ inputValue, inputEvents }">
                                <b-form-input
                                    :value="inputValue"
                                    v-on="inputEvents"
                                    :readonly="true"
                                    style="background-color:#ffffff;"
                                ></b-form-input>
                              </template>
                            </DatePickerX>
                            <font-awesome-icon
                              icon="calendar"
                              style="
                                float: right !important;
                                position: absolute;
                                right: 35px;
                                top: 30px;
                                color: gray;
                              "
                            />
                            <b-form-invalid-feedback>
                              {{
                                inputDokter.error &&
                                inputDokter.error.masa_berlaku.desc
                              }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <b-col sm="3">
                          <div role="group">
                            <b-form-input
                              v-model="tmpInputDokterData[index].nik"
                              :ref="'nik' + index"
                              @change="
                                onChangeValue({
                                  label: 'nik',
                                  index,
                                  $event
                                })
                              "
                              
                              @input="
                                onInputNik(
                                  $event,
                                  index,
                                  inputDokter,
                                  'nik'
                                )
                              "
                              :state="
                                errorState({ label: 'nik', index })
                              "
                              maxlength="16"
                              oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')"
                            ></b-form-input>
                            <b-form-invalid-feedback>
                              {{
                                inputDokter.error &&
                                inputDokter.error.nik.desc
                              }}
                            </b-form-invalid-feedback>
                          </div>
                        </b-col>
                      </b-row>
                      <div class="row">
                        <div class="col text-center">
                          <b-button
                            v-if="index > 0"
                            variant="danger"
                            class="mr-3"
                            :style="btnRemoveMobileStyle"
                            @click="removeInputDokterData(index)"
                          >
                            <font-awesome-icon icon="minus" />
                          </b-button>

                          <b-button
                            variant="first"
                            style="padding: .5rem .8rem; border-radius: 100%; background-color:#1bbf2c;border-color:transparent"
                            class=""
                            @click="addInputDokterData"
                          >
                            <font-awesome-icon icon="plus" />
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="d-flex align-items-center">
                <b-col lg="8" md="7" sm="6"> </b-col>
                <b-col lg="4" md="5" sm="6" align="right">
                  <b-button
                    class="text-capitalize mr-2"
                    variant="danger"
                    :to="{ name: 'dokter-list' }"
                    >tutup</b-button
                  >
                  <b-button
                   
                    type="submit"
                    variant="primary"
                    >Selesai</b-button
                  >
                </b-col>
              </b-row>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import {mapGetters} from "vuex";
import startCase from "lodash/startCase";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlus, faMinus, faCalendar } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
moment.locale('id');
library.add(faPlus, faMinus, faCalendar);

export default {
  components: {
    "vue-select": () => import("@/components/VueSelect.vue"),
    DatePickerX: () => import('v-calendar/lib/components/date-picker.umd'),
  },
  data: () => ({
    spesialisasiList: [],
    tmpInputDokterData: [
      {
        kode_dokter_bpjs: null,
        nama: null,
        email: null,
        nomor_telp:null,
        nomor_sip: null,
        masa_berlaku: null,
        spesialisasi: null,
        nik: null,
        error: {
          nama: null,
          email: null,
          nomor_telp:null,
          nomor_sip: null,
          masa_berlaku: null,
          spesialisasi: null,
          nik: null,
        }
      }
    ],
    kodeContainer: [],
    namaContainer: [],
    beingSubmit: false,
    allLayananContainer: [],
    namaLayananContainer: [],
    tlpLayananContainer: [],
    nikLayananContainer: [],
    emailLayananContainer: [],
    sipLayananContainer: [],
    kodeBpjsContainer: [],
    tlpLayananExistsInDb: [],
    nikLayananExistsInDb: [],
    emailLayananExistsInDb: [],
    sipLayananExistsInDb: [],
    dokterBpjsList: [],
  }),
  computed: {
    ...mapGetters(["getKlinikId", "bpjsAuthValid"]),
    btnRemoveMobileStyle() {
      if (this.isMobile()) {
        return {
          padding: ".4rem .7rem",
          "border-radius": "100%",
          "margin-left": "-22px"
        };
      }

      return {
        padding: ".5rem .8rem",
        "border-radius": "100%",
        "margin-left": "-8px"
      };
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.beingSubmit && localStorage.getItem("IDLE") != 1) {
      this.$swal({
        title: startCase("keluar"),
        text: `Anda yakin untuk keluar dari halaman ini?`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: startCase("tidak"),
        confirmButtonText: startCase("ya")
      }).then(res => {
        if (res.value) {
          next();
        } else {
          next(false);
        }
      });
    } else {
      next();
    }
  },
  created() {
    this.getDokterBpjs();
    this.getSpesialisasi();
    this.tmpInputDokterData = this.setTmpInputDokterData();
  },
  methods: {
    async getSpesialisasi() {
      try {
        const res = await axios.get(
          `${this.url_api}/spesialisasi`
        );
        const { data } = res.data;
        this.spesialisasiList = data.spesialisasi.map(item => {
          return {
            id: item.id,
            label: item.nama
          };
        });
      } catch (error) {}

    },
    async getDokterBpjs() {
      try {
        const res = await axios.get(
          `${this.url_api}/bpjs/dokter?klinik_id=${this.getKlinikId}&first_row=0&limit=15`
        );
     
        this.dokterBpjsList = res.data.response.list.map(item => {
          return {
            id: item.kdDokter,
            label: `${item.kdDokter} - ${item.nmDokter}`,
            name: item.nmDokter
          };
        });
      } catch (error) {}
    },
    setTmpInputDokterData() {
      return this.tmpInputDokterData.map(item => {
        const tmp = Object.keys(item).reduce((obj, key) => {
          if (key !== "error") {
            obj[key] = this.generateErrorObj();
          }
          return obj;
        }, {});
        return {
          ...item,
          error: tmp
        };
      });
    },
    generateErrorObj() {
      return {
        error: null,
        desc: null,
      };
    },
    errorState({ label, index }) {
      const { tmpInputDokterData } = this;
      if (
        tmpInputDokterData[index].error &&
        tmpInputDokterData[index].error[label]
      ) {
        return tmpInputDokterData[index].error[label].error;
      } else {
        return null;
      }
    },
    errorDesc({ label, index }) {
      const { tmpInputDokterData } = this;
      if (
        tmpInputDokterData[index].error &&
        tmpInputDokterData[index].error[label]
      ) {
        return tmpInputDokterData[index].error[label].desc;
      }
    },
    onKeyupTarif($event, index) {
      const { tmpInputDokterData } = this;

      var evt = $event;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    placeholderInput(label = "") {
      return startCase(`input ${label}`);
    },
    validateInput({ label, $event }) {
      return {
        error: ($event && true) || false,
        desc: (!$event && "kolom harus diisi") || ""
      };
    },
    validateAll() {
      const valItems = ["nama", "email","nomor_telp", "nomor_sip", "masa_berlaku", "spesialisasi", "nik"];
      this.tmpInputDokterData.forEach(item => {
        valItems.forEach(valItem => {
          if (item.error[valItem].error == false) return;

          let label
          if(valItem == "nomor_telp") label = "no_handphone"
          else if(valItem == "nama") label = "nama_dokter"
          else if(valItem == "nomor_sip") label = "sip"
          else label = valItem

          if (!item[valItem]) {
            item.error[valItem].error = false;
            item.error[valItem].desc = "Kolom harus diisi"
          } else {
            item.error[valItem].error = true;
            item.error[valItem].desc = "";
          }
        });
      });
    },
    submitInputDokter() {
      const { tmpInputDokterData, validateAll } = this;
      this.$nextTick(() => {
        validateAll();

        let isError = false;
        let isErrorRequired = false;
        let isErrorDuplicate = false;
        let isErrorExists = false;
        let shouldSkip = false;
        let errorKey = []

        tmpInputDokterData.forEach((dokterData, index) => {
          if(shouldSkip) return

          for (let errIndex in dokterData.error) {
            if (dokterData.error[errIndex].error == false) {
              isError = true;
              errorKey.push(errIndex)

              if (/(harus diisi)/i.test(dokterData.error[errIndex].desc)) {
                isErrorRequired = true;
              } else if (
                /(telah ditambahkan)/i.test(dokterData.error[errIndex].desc)
              ) {
                isErrorDuplicate = true;
              } else if (/(sudah ada)/i.test(dokterData.error[errIndex].desc)) {
                isErrorExists = true;
              }
            }
            
            if(errorKey.includes('nama')) {
              this.$refs['nama' + index][0].focus();
              shouldSkip = true
            } else if(errorKey.includes('email')) {
              this.$refs['email' + index][0].focus();
              shouldSkip = true
            } else if(errorKey.includes('nomor_telp')) {
              this.$refs['nomor_telp' + index][0].focus();
              shouldSkip = true
            } else if(errorKey.includes('nik')) {
              this.$refs['nik' + index][0].focus();
              shouldSkip = true
            } else if(errorKey.includes('nomor_sip')) {
              this.$refs['nomor_sip' + index][0].focus();
              shouldSkip = true
            } else if(errorKey.includes('masa_berlaku')) {
              this.$refs['nomor_sip' + index][0].focus();
              let i = 260 + (index * 260)
              window.scrollTo({
                  top: i,
                  behavior: 'smooth'
              });
              this.$refs['nomor_sip' + index][0].blur();
              shouldSkip = true
            } else if(errorKey.includes('spesialisasi')) {
              this.$refs['nomor_sip' + index][0].focus();
              let i = 260 + (index * 260)
              window.scrollTo({
                  top: i,
                  behavior: 'smooth'
              });
              this.$refs['nomor_sip' + index][0].blur();
              shouldSkip = true
            }
          }
        });

        if (isError == false) {
          this.$swal({
            text: `Anda yakin untuk menyelesaikan penambahan data ini?`,
            type: "warning",
            showCancelButton: true,
            cancelButtonText: startCase("tidak"),
            confirmButtonText: startCase("ya")
          }).then(res => {
            if (res.value) {
              this.doSubmitInputDokter();
            }
          });
        } else {
          let errorMessage = {
            required: "Silakan cek kembali pengisian data Anda!"
          };
          let jenisError = "";
          if (isErrorRequired) jenisError = "required";
          else if (isErrorDuplicate) jenisError = "duplicate";
          else if (isErrorExists) jenisError = "exists";
          this.$swal({
            type: "warning",
            text: errorMessage[jenisError] || "Silakan cek kembali pengisian data Anda!"
          });
        }
      });
    },
    async doSubmitInputDokter() {
      const { constructPostData } = this;
      
      try {
        const res = await axios.post(
          `${this.url_api}/klinik/dokter`, {
            arr: constructPostData()
          }
        );
        const { status, data } = res.data;
        if(status) {
          this.beingSubmit = true;
          this.$swal({
            text: "User berhasil ditambahkan. Email aktivasi telah dikirimkan kepada user yang ditambahkan!",
            type: "success",
            confirmButtonText: startCase("OK")
          });
            this.$router.push({ path: "/dokter" });
        } else {
          this.$swal({
            text: "User gagal ditambahkan.",
            type: "warning",
            confirmButtonText: startCase("OK")
          });
        }
      } catch (errror) {
        const x = errror.response.data;
        const y = Object.keys(x);
        y.map(item => {
          const z = item.split(".");
          this.tmpInputDokterData[z[1]].error.nama.desc =
            x[item][x[item].length - x[item].length];
        });
        var d = errror.response.data.length;
      }
    },
    constructPostData() {
      const { tmpInputDokterData } = this;
      const tmp = tmpInputDokterData.map(item => {
        const x = Object.keys(item).filter(y => !["error"].includes(y));
        const z = x.reduce((obj, key) => {
          let q = key;
          if (q == 'masa_berlaku') obj['masa_berlaku_sip'] = moment(item[key]).format("YYYY-MM-DD")
          else if (q == 'spesialisasi') obj['spesialisasi_id'] = item[key] ? item[key].id : null;
          else if (q == 'kode_dokter_bpjs') obj['kode_bpjs'] = item[key] ? item[key].id : null;
          else obj[q] = item[key];
          return obj;
        }, {});
        z.klinik_id = this.getKlinikId;
        return z;
      });
      return tmp;
    },
    onChangeValue({ index, label, $event }) {
      const { tmpInputDokterData, validateInput } = this;
      const tmp = tmpInputDokterData[index];
      if (tmp.error[label].error !== false) {
        tmp.error[label] = validateInput({
          label,
          $event
        });
      }

      if (label !== "email") {
        tmp[label] = $event;
        Vue.set(this.tmpInputDokterData, index, tmp);
      }
    },
    onInputData(valRaw, index, o, p) {
      if (this._timeoutNamaDokter) clearTimeout(this._timeoutNamaDokter);
      let val = p == 'masa_berlaku' || p == 'spesialisasi'  ? valRaw : valRaw.toLowerCase().trim();

      Vue.set(o, p, valRaw);
      Vue.set(this.allLayananContainer, index, val);

      if (!val) {
        this.tmpInputDokterData[index].error[p].error = false;
        this.tmpInputDokterData[index].error[p].desc =
          startCase(p) + " harus diisi";
        return;
      }

      let isDuplicate = false;
      let needDbChecks = [];

      this.allLayananContainer.forEach((item, i) => {
        if (isDuplicate == false) {
          this.tmpInputDokterData[i].error[p].error = true;
          this.tmpInputDokterData[i].error[p].desc = "";

          needDbChecks.push(i);
        }
      });
    },
    checkDuplicateKodeBpjs() {
      let isDuplicate = false;
      this.kodeBpjsContainer.forEach((item, i) => {
        isDuplicate = false;
        this.kodeBpjsContainer.forEach((item2, j) => {
          if(i == j) return;
          if(item.id == item2.id) {
            this.tmpInputDokterData[i].error["kode_dokter_bpjs"].error = false;
            this.tmpInputDokterData[i].error["kode_dokter_bpjs"].desc = "Kode dokter tidak boleh sama";
            this.tmpInputDokterData[i].error["nama"].error = false;
            this.tmpInputDokterData[i].error["nama"].desc = "Nama tidak boleh sama";
            isDuplicate = true;
          }
        });
        if(!isDuplicate) {
          this.tmpInputDokterData[i].error["kode_dokter_bpjs"].error = true;
          this.tmpInputDokterData[i].error["kode_dokter_bpjs"].desc = "";
          this.tmpInputDokterData[i].error["nama"].error = true;
          this.tmpInputDokterData[i].error["nama"].desc = "";
        }
      })
    },
    onInputKodeBpjs(val, index, o, p) {
      // initial errors
      this.tmpInputDokterData[index].error["kode_dokter_bpjs"].error = true;
      this.tmpInputDokterData[index].error["kode_dokter_bpjs"].desc = "";
      this.tmpInputDokterData[index].error["nama"].error = true;
      this.tmpInputDokterData[index].error["nama"].desc = "";

      if (!Object(val).hasOwnProperty('label')) {
        return;
      } 

      o.nama = val.name;
      Vue.set(o, p, val);
      Vue.set(this.kodeBpjsContainer, index, val);

      if (this.kodeBpjsContainer.length > 1) {
        this.checkDuplicateKodeBpjs();
      }
    },
    onInputSIP(val, index, o, p) {
      if (this._timeoutKodeLayanan) clearTimeout(this._timeoutKodeLayanan);
      Vue.set(o, p, val);
      Vue.set(this.sipLayananContainer, index, val);

      if (val.length == 0) {
        this.tmpInputDokterData[index].error["nomor_sip"].error = false;
        this.tmpInputDokterData[index].error["nomor_sip"].desc =
          "Kolom harus diisi";
        return;
      }

      let isDuplicate = false;
      let needDbChecks = [];
      this.sipLayananContainer.forEach((item, i) => {
        isDuplicate = false;
        this.sipLayananContainer.forEach((item2, i2) => {
          if (i != i2) {
            if (item == item2) {
              this.tmpInputDokterData[i].error["nomor_sip"].error = false;
              this.tmpInputDokterData[i].error["nomor_sip"].desc =
                "SIP tidak boleh sama";
              isDuplicate = true;
            }
          }
        });
        if (isDuplicate == false) {
          this.tmpInputDokterData[i].error["nomor_sip"].error = true;
          this.tmpInputDokterData[i].error["nomor_sip"].desc = "";
          needDbChecks.push(i);
        }
      });

      if (needDbChecks.length > 0) {
        let newNeedDbChecks = [];
        needDbChecks.forEach(item => {
          let valDb = this.tmpInputDokterData[item].nomor_sip;
          if (this.sipLayananExistsInDb.indexOf(valDb) > -1) {
            this.tmpInputDokterData[item].error["nomor_sip"].error = false;
            this.tmpInputDokterData[item].error["nomor_sip"].desc =
              "SIP telah terdaftar";
          } else newNeedDbChecks.push(item);
        });
        needDbChecks = newNeedDbChecks;

        this._timeoutKodeLayanan = setTimeout(() => {
          needDbChecks.forEach(item => {
            axios
              .post(
                `${this.url_api}/klinik/dokter/sip/cek`,
                {
                  klinik_id: this.getKlinikId,
                  sip: this.tmpInputDokterData[item].nomor_sip
                }
              )
              .then(response => {
                if (response.data.status == false) {
                  this.tmpInputDokterData[item].error[
                    "nomor_sip"
                    ].error = false;
                  this.tmpInputDokterData[item].error["nomor_sip"].desc =
                    "SIP telah terdaftar";
                  this.sipLayananExistsInDb.push(
                    this.tmpInputDokterData[item].nomor_sip
                  );
                }
              })
              .catch(error => {})
              .finally(() => {
                clearTimeout(this._timeoutKodeLayanan);
              });
          });
        }, 600);
      }
    },
    onInputNik(val, index, o, p) {
      if (this._timeoutKodeLayanan) clearTimeout(this._timeoutKodeLayanan);
      Vue.set(o, p, val);
      Vue.set(this.nikLayananContainer, index, val);

      if (val.match(/[^0-9/]+/) !== null) {
        this.tmpInputDokterData[index].error["nik"].error = false;
        this.tmpInputDokterData[index].error["nik"].desc =
          "Hanya bisa menulis angka";
        return;
      }

      if (val.length == 0) {
        this.tmpInputDokterData[index].error["nik"].error = false;
        this.tmpInputDokterData[index].error["nik"].desc =
          "Kolom harus diisi";
        return;
      } else if (val.length < 16) {
        this.tmpInputDokterData[index].error["nik"].error = false;
        this.tmpInputDokterData[index].error["nik"].desc =
          "NIK minimal 16 karakter";
        return;
      }

      let isDuplicate = false;
      let needDbChecks = [];
      this.nikLayananContainer.forEach((item, i) => {
        isDuplicate = false;
        this.nikLayananContainer.forEach((item2, i2) => {
          if (i != i2) {
            if (item == item2) {
              this.tmpInputDokterData[i].error["nik"].error = false;
              this.tmpInputDokterData[i].error["nik"].desc =
                "NIK tidak boleh sama";
              isDuplicate = true;
            }
          }
        });
        if (isDuplicate == false) {
          this.tmpInputDokterData[i].error["nik"].error = true;
          this.tmpInputDokterData[i].error["nik"].desc = "";
          needDbChecks.push(i);
        }
      });

      if (needDbChecks.length > 0) {
        let newNeedDbChecks = [];
        needDbChecks.forEach(item => {
          let valDb = this.tmpInputDokterData[item].nik;
          if (this.nikLayananExistsInDb.indexOf(valDb) > -1) {
            this.tmpInputDokterData[item].error["nik"].error = false;
            this.tmpInputDokterData[item].error["nik"].desc =
              "NIK telah didaftarkan";
          } else newNeedDbChecks.push(item);
        });
        needDbChecks = newNeedDbChecks;

        this._timeoutKodeLayanan = setTimeout(() => {
          needDbChecks.forEach(item => {
            axios
              .get(
                `${this.url_api}/klinik/dokter/nik/cek`,
                {
                  params: {
                    klinik_id: this.getKlinikId,
                    nik: this.tmpInputDokterData[item].nik
                  }
                }
              )
              .then(response => {
                if (response.data.status == false) {
                  this.tmpInputDokterData[item].error[
                    "nik"
                  ].error = false;
                  this.tmpInputDokterData[item].error["nik"].desc =
                    "NIK telah didaftarkan";
                  this.nikLayananExistsInDb.push(
                    this.tmpInputDokterData[item].nik
                  );
                }
              })
              .catch(error => {})
              .finally(() => {
                clearTimeout(this._timeoutKodeLayanan);
              });
          });
        }, 600);
      }
    },
    onInputNomorTelp(val, index, o, p) {
      if (this._timeoutKodeLayanan) clearTimeout(this._timeoutKodeLayanan);
      Vue.set(o, p, val);
      Vue.set(this.tlpLayananContainer, index, val);

      if (val.match(/[^0-9/]+/) !== null) {
        this.tmpInputDokterData[index].error["nomor_telp"].error = false;
        this.tmpInputDokterData[index].error["nomor_telp"].desc =
          "Hanya bisa menulis angka";
        return;
      }

      if (val.length == 0) {
        this.tmpInputDokterData[index].error["nomor_telp"].error = false;
        this.tmpInputDokterData[index].error["nomor_telp"].desc =
          "Kolom harus diisi";
        return;
      } else if (val.length < 10) {
        this.tmpInputDokterData[index].error["nomor_telp"].error = false;
        this.tmpInputDokterData[index].error["nomor_telp"].desc =
          "No. Handphone minimal 10 karakter";
        return;
      } else if(val.length > 15) {
        this.tmpInputDokterData[index].error["nomor_telp"].error = false;
        this.tmpInputDokterData[index].error["nomor_telp"].desc =
          "No. Handphone maksimal 15 karakter";
        return;
      }

      let isDuplicate = false;
      let needDbChecks = [];
      this.tlpLayananContainer.forEach((item, i) => {
        isDuplicate = false;
        this.tlpLayananContainer.forEach((item2, i2) => {
          if (i != i2) {
            if (item == item2) {
              this.tmpInputDokterData[i].error["nomor_telp"].error = false;
              this.tmpInputDokterData[i].error["nomor_telp"].desc =
                "No. Handphone tidak boleh sama";
              isDuplicate = true;
            }
          }
        });
        if (isDuplicate == false) {
          this.tmpInputDokterData[i].error["nomor_telp"].error = true;
          this.tmpInputDokterData[i].error["nomor_telp"].desc = "";
          needDbChecks.push(i);
        }
      });

      if (needDbChecks.length > 0) {
        let newNeedDbChecks = [];
        needDbChecks.forEach(item => {
          let valDb = this.tmpInputDokterData[item].nomor_telp;
          if (this.tlpLayananExistsInDb.indexOf(valDb) > -1) {
            this.tmpInputDokterData[item].error["nomor_telp"].error = false;
            this.tmpInputDokterData[item].error["nomor_telp"].desc =
              "No. Handphone telah didaftarkan";
          } else newNeedDbChecks.push(item);
        });
        needDbChecks = newNeedDbChecks;

        this._timeoutKodeLayanan = setTimeout(() => {
          needDbChecks.forEach(item => {
            axios
              .get(
                `${this.url_api}/klinik/dokter/phone/cek`,
                {
                  params: {
                    klinik_id: this.getKlinikId,
                    phone: this.tmpInputDokterData[item].nomor_telp
                  }
                }
              )
              .then(response => {
                if (response.data.status == false) {
                  this.tmpInputDokterData[item].error[
                    "nomor_telp"
                  ].error = false;
                  this.tmpInputDokterData[item].error["nomor_telp"].desc =
                    "No. Handphone telah didaftarkan";
                  this.tlpLayananExistsInDb.push(
                    this.tmpInputDokterData[item].nomor_telp
                  );
                }
              })
              .catch(error => {})
              .finally(() => {
                clearTimeout(this._timeoutKodeLayanan);
              });
          });
        }, 600);
      }
    },
    onInputEmail(val, index, o, p) {
      if (this._timeoutKodeLayanan) clearTimeout(this._timeoutKodeLayanan);
      Vue.set(o, p, val);
      Vue.set(this.emailLayananContainer, index, val);

      if (val == "" || val == null) {
        this.tmpInputDokterData[index].error["email"].error = false;
        this.tmpInputDokterData[index].error["email"].desc =
          "Kolom harus diisi";
        return;
      } else if(val.match(/^([A-Za-z][A-Za-z0-9\-\.\_\+]*)\@([A-Za-z][A-Za-z0-9\-\_\+]*)(\.[A-Za-z][A-Za-z0-9\-\_\+]*)+$/) == null) {
        this.tmpInputDokterData[index].error["email"].error = false;
        this.tmpInputDokterData[index].error["email"].desc =
          "Format email salah";
        return;
      }

      let isDuplicate = false;
      let needDbChecks = [];
      this.emailLayananContainer.forEach((item, i) => {
        isDuplicate = false;
        this.emailLayananContainer.forEach((item2, i2) => {
          if (i != i2) {
            if (item == item2) {
              this.tmpInputDokterData[i].error["email"].error = false;
              this.tmpInputDokterData[i].error["email"].desc =
                "Email tidak boleh sama";
              isDuplicate = true;
            }
          }
        });
        if (isDuplicate == false) {
          this.tmpInputDokterData[i].error["email"].error = true;
          this.tmpInputDokterData[i].error["email"].desc = "";
          needDbChecks.push(i);
        }
      });

      if (needDbChecks.length > 0) {
        let newNeedDbChecks = [];
        needDbChecks.forEach(item => {
          let valDb = this.tmpInputDokterData[item].email;
          if (this.emailLayananExistsInDb.indexOf(valDb) > -1) {
            this.tmpInputDokterData[item].error["email"].error = false;
            this.tmpInputDokterData[item].error["email"].desc =
              "Email telah ditambahkan";
          } else newNeedDbChecks.push(item);
        });
        needDbChecks = newNeedDbChecks;

        this._timeoutKodeLayanan = setTimeout(() => {
          needDbChecks.forEach(item => {
            axios
              .get(
                `${this.url_api}/klinik/dokter/email/cek`,
                {
                  params: {
                    klinik_id: this.getKlinikId,
                    email: this.tmpInputDokterData[item].email
                  }
                }
              )
              .then(response => {
                if (response.data.status == false) {
                  this.tmpInputDokterData[item].error[
                    "email"
                    ].error = false;
                  this.tmpInputDokterData[item].error["email"].desc =
                    "Email telah didaftarkan";
                  this.emailLayananExistsInDb.push(
                    this.tmpInputDokterData[item].email
                  );
                }
              })
              .catch(error => {})
              .finally(() => {
                clearTimeout(this._timeoutKodeLayanan);
              });
          });
        }, 600);
      }
    },
    addInputDokterData() {
      const { tmpInputDokterData, validateAll, generateErrorObj } = this;
      const lastIndex = tmpInputDokterData[tmpInputDokterData.length - 1];
      const x = Object.keys(lastIndex);
      const tmp = x.reduce((obj, key) => {
        if (key === "error") {
          obj[key] = x
            .filter(item => item !== "error")
            .reduce((obj, keyChild) => {
              obj[keyChild] = generateErrorObj();
              return obj;
            }, {});
        } else if (key === "id") {
          obj[key] = tmpInputDokterData.length + 1;
        } else {
          obj[key] = null;
        }
        return obj;
      }, {});
      validateAll();
      this.tmpInputDokterData = [...tmpInputDokterData, tmp];
    },
    removeInputDokterData(index) {
      const { tmpInputDokterData } = this;
      if (tmpInputDokterData.length > 1) {
        const tmp = tmpInputDokterData
          .slice(0, index)
          .concat(
            tmpInputDokterData.slice(index + 1, tmpInputDokterData.length)
          );
        this.tmpInputDokterData = tmp;
        this.emailLayananContainer = tmp.map(item => {
          return item.email
        });
        this.namaLayananContainer = tmp.map(item => {
          return item.nama
        });
        this.tlpLayananContainer = tmp.map(item => {
          return item.nomor_telp
        });
        this.sipLayananContainer = tmp.map(item => {
          return item.nomor_sip
        });
        this.nikLayananContainer = tmp.map(item => {
          return item.nik
        });

        this.tmpInputDokterData.forEach((v,i) => {
          if(v.email != null && v.email != "") this.onInputEmail(v.email, i, v, 'email')
          if(v.nomor_telp != null && v.nomor_telp != "") this.onInputNomorTelp(v.nomor_telp, i, v, 'nomor_telp')
          if(v.nomor_sip != null && v.nomor_sip != "") this.onInputSIP(v.nomor_sip, i, v, 'nomor_sip')
          if(v.nik != null && v.nik != "") this.onInputNik(v.nik, i, v, 'nik')
          this.validateAll()
        })
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.invalid-feedback {
  min-height: 18px;
  display: block;
}
</style>
